import { navMenuLoader } from '../../rankers/components/nav_menu/nav_menu_loader';
navMenuLoader();

import { navMenuItemsLoader } from '../../rankers/components/nav_menu_items/nav_menu_items_loader';
navMenuItemsLoader();
